
const listOfResources = [
    'billing',
];

export default {
    order: 20,
    apply: (permissionsMap = {}, grantedPermissions = [], context = {}) => {
        const out = { ...permissionsMap };

        const { ravenCount = 0 } = context;

        if(ravenCount === 0) {
            console.warn("Permissions: no ravens found in context, removing raven-related permissions");
            // if there are no ravens, remove any permissions except for billing
            Object.keys(out).forEach(resource => {
                if(!listOfResources.includes(resource)) {
                    delete out[resource];
                }
            });
        }

        return out;
    }
}